import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../../service/server/server.service';
import { MessageService } from '../../../service/message/message.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
@Component({
  selector: 'app-reception-new-sms',
  templateUrl: './reception-new-sms.component.html',
  styleUrls: ['./reception-new-sms.component.scss']
})
export class ReceptionNewSmsComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public lang = JSON.parse(<any>localStorage.getItem('lang'));
  public loading: boolean = false;
  public loading2: boolean = false;
  public subscription: Subscription | any;
  public server_main!: any;
  public server!: any;
  public user_id!: number;
  public reception_id!: number;
  public creator!: number;
  public user_title!: string;
  public reception_code!: number;
  public user_cellphone!: string;
  public Link!: string;
  public store_title!: string;
  public store_phone!: string;

  constructor(
    public serverService: ServerService,
    public dialog: MatDialog,
    public router: Router,
    public matSnackBar: MatSnackBar,
    public messageService: MessageService,
    public _dialogRef: MatDialogRef<ReceptionNewSmsComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any
  ) {
    this.server = this.serverService.get_server();
    this.server_main = this.serverService.get_server();
    if (dialog_data) {
      this.reception_id = dialog_data.reception_id;
      this.creator = dialog_data.creator;
    }
  }//end consructor
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id
    }
    this.get_data();
  }

  get_data() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 7240,
      'reception_id': this.reception_id,
      'creator': this.creator,
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.store_title = res['result'][0].store_title;
            this.store_phone = res['result'][0].store_phone;
            this.reception_code = res['result'][0].repairman_reception_code;
            this.user_cellphone = res['result'][0].user_cellphone;
            this.user_title = res['result'][0].user_title;
            this.Link = this.serverService.get_my_domain() + "/tracking/" + this.reception_id + "/" + this.reception_code;
          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }

  check_charge_sms(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    const phonePattern = /^\d{11}$/;
    if (!phonePattern.test(this.user_cellphone)) {
      var pe_message = "فرمت شماره برای ارسال پیامک معتبر نمی باشد";
      this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
      return false;
    }
    var x = window.confirm(this.messageService.message_sms_accept());
    if (x == false) {
      this.message(false, "", 1, this.messageService.close());
      return false;
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', { 'address': 6312, 'creator': this.creator }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            if (res['result'][0].amount >= 5000) {
              this.send_sms();
            }
            else {
              var pe_message = "قادر به ارسال پیامک نمی باشید لطفا شارژ نمائید";
              this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
            }
          }
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  send_sms(): any {
    var token = this.serverService.get_my_domain() + "/tracking/" + this.reception_id;
    var obj = {
      'address': 7233,
      'reception_id': this.reception_id,
      'token': token,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any) => {
        this.serverService.send_sms_charge();
        var pe_message = "پیامک با موفقیت ارسال شد";
        this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
      })
  }
  close() {
    this._dialogRef.close();
  }
  //**************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
